import moment from 'moment';

const sixtyDaysAgo = moment().subtract(60, 'days');

export const getLastSoldFilter = (anchorDate?: string) => {
  if (!anchorDate) {
    return { lastSoldAt: { $gte: sixtyDaysAgo.startOf('day').toDate() } };
  }
  return { lastSoldAt: { $gte: moment(anchorDate).startOf('day').toDate() } };
};
